/**
   Gets the values of specified parameters from the given URL string
   @param {string} url - The URL string to extract the parameter values from
   @param {string[]} paramsToSearch - An array of parameter names to search for in the URL string
   @returns {Record<string, string>} An object with key-value pairs where each key is a parameter name and each value is the last occurrence of that parameter in the URL string
 */
export const getUrlParams = (
  url: string,
  paramsToSearch: string[]
): Record<string, string> => {
  const result: Record<string, string> = {};

  const regex = /[?&]([^=]+)=([^&#]*)/g;
  let match;
  while ((match = regex.exec(url))) {
    const key = decodeURIComponent(match[1]);
    const value = decodeURIComponent(match[2]);
    if (paramsToSearch.includes(key)) {
      result[key] = value;
    }
  }

  return result;
};

export const parseJson = (text: string) => {
  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
};
